import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
} from "@angular/core";
import { CanvasService } from "../canvas-service.interface";

/**
 * Generated class for the CanvasGroupComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "canvas-group",
  templateUrl: "canvas-group.html",
})
export class CanvasGroupComponent implements AfterViewInit {
  @Input() canvasService: CanvasService;
  @Input() height = 100;
  @Input() width = 100;
  @Input() pointsMovable: boolean = true;

  categories: string[] = [];
  currentCategory: string;
  subscriptions: Array<any> = [];

  constructor(private cdr: ChangeDetectorRef) {
    // console.log('Hello CanvasGroupComponent Component');
  }

  ngAfterViewInit(): void {
    this.categories = this.canvasService.getCategories();
    // console.log( "Got categories: ", this.categories );

    this.subscriptions.push(
      this.canvasService.getCategoryObservable().subscribe((category) => {
        this.currentCategory = category;
      })
    );
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  categorySelected(category: string) {
    console.log("Category picked: ", category);
    this.canvasService.setCategory(category);
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/canvas/canvas-group/canvas-group.ts